module.exports = __webpack_public_path__ + "img/win_ball_red.94ffa52b.png";